module.exports = __webpack_public_path__ + "static/media/silentnite.0c74bf5f.png";